module.exports = __webpack_public_path__ + "img/doesnt_subscribe.e282cf28.png";